/**
 * Dropdown Alpine component.
 * @param attribute
 * @param config
 * @return {{searchTerm: string, defaultValue: {name: string, slug: string}, setValue(*): *, options: ({name: string, slug: string}|{name: string, slug: string}|{name: string, slug: string}|{name: string, slug: string}|{name: string, slug: string})[], readonly filteredOptions: (({name: string, slug: string}|{name: string, slug: string}|{name: string, slug: string}|{name: string, slug: string}|{name: string, slug: string})[]), toggle(): (*|undefined), value: null, close(*=): undefined, open: boolean}|({name: string, slug: string}|{name: string, slug: string}|{name: string, slug: string}|{name: string, slug: string}|{name: string, slug: string})[]|*}
 */
const dropdown = (attribute, config = {}) => {
    let defaults = {
        attribute,

        label: "",
        value: null,
        options: [],

        open: false,
        disabled: false,

        search: false,
        searchTerm: "",

        get isDisabled() {
            return this.disabled || !this.options.length;
        },

        get filteredOptions() {
            if (!this.search || !this.searchTerm) return this.options;

            return this.options.filter((element) => {
                let _needle = this.searchTerm.toLowerCase(),
                    _haystack = element.label.toLowerCase();
                return _haystack.includes(_needle);
            });
        },

        get optionCode() {
            if (this.value === null) return false;
            let option = this.options.find((opt) => opt.value === this.value);
            return option ? option.code : false;
        },

        get optionLabel() {
            if (this.value === null) return false;
            let option = this.options.find((opt) => opt.value === this.value);
            return option ? option.label : false;
        },

        toggle() {
            if (this.open) {
                return this.close();
            }

            this.$refs.button.focus();

            this.open = true;
        },

        close(focusAfter) {
            if (!this.open) return;

            this.open = false;

            focusAfter && focusAfter.focus();
        },

        setValue(value) {
            this.value = value;
            this.searchTerm = "";

            return this.close();
        },

        onInput(event) {
            let val = event.target.value;
            this.setValue(val);
        }
    };

    return Object.assign(defaults, config);
};

module.exports = dropdown;
